import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Box,
  Button,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

function DeleteUserCard({ onOpenDeleteDialog, isCurrentUser }) {
  return (
    <Card sx={{ bgcolor: '#2C2C2F', color: '#fff', borderRadius: 3 }}>
      <CardHeader title="Excluir Usuário" sx={{ borderBottom: '1px solid #444' }} />
      <CardContent>
        <Typography sx={{ color: '#bdbdbd', mb: 2 }}>
          Esta ação é irreversível e removerá permanentemente o usuário.
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant="contained"
            color="error"
            startIcon={<DeleteIcon />}
            onClick={onOpenDeleteDialog}
            disabled={isCurrentUser}
          >
            Excluir
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
}

export default DeleteUserCard;
